import { useDispatch } from "react-redux";
import { setModalContents } from "../../store/scheduler";
import BottomNav from "../BottomNav.jsx";

export default function DemoModeModal() {
  const dispatch = useDispatch();

  const handleClose = (e) => {
    e.preventDefault();
    dispatch(setModalContents(""));
  };

  return (
    <>
      <h1 className="heading">Booking Disabled</h1>
      <p>
        This is a demo environment. Appointment booking has been disabled.
      </p>
      <BottomNav
        continueLabel="Close"
        handleContinue={handleClose}
        enableContinue={true}
        hideCancel={true}
      />
    </>
  );
}
